import { Box, Button, Text, Textarea } from "@chakra-ui/react";
import { useState } from "react";
import { AiOutlineCheckCircle, AiOutlineCloseCircle } from "react-icons/ai";
import { BiCircle } from "react-icons/bi";
import { useIntl } from "react-intl";

import { FieldDescription } from "./field-description";
import { PartialScenarioReview } from "./quality-control-types";

interface EditSingleQualityControlItemProps {
  wholeReview: PartialScenarioReview;
  field: keyof PartialScenarioReview;
  setReview(review: PartialScenarioReview): void;
  stopEditing(): void;
}

export function EditSingleQualityControlItem({
  wholeReview,
  field,
  setReview,
  stopEditing,
}: EditSingleQualityControlItemProps) {
  const intl = useIntl();
  const review = wholeReview[field];

  const [check, setCheck] = useState<boolean | undefined>(review.ok);
  const [comment, setComment] = useState<string>(review.comment ?? "");

  const onSubmit = () => {
    setReview({
      ...wholeReview,
      [field]: {
        ok: check,
        comment,
      },
    });
    stopEditing();
  };

  return (
    <Box
      border="1px solid #ccc"
      rounded="md"
      p="12px"
      alignItems="center"
      my="12px"
      _hover={{
        cursor: "pointer",
      }}
    >
      <Box p="4px">
        <Text fontWeight="normal">
          <FieldDescription field={field} />
        </Text>
        <Button
          p="4px"
          bg="white"
          onClick={() => {
            if (check === true) {
              setCheck(false);
            }
            if (check === false) {
              setCheck(undefined);
            }
            if (check === undefined) {
              setCheck(true);
            }
          }}
        >
          {check === true ? (
            <AiOutlineCheckCircle color="green" size="22px" />
          ) : check === false ? (
            <AiOutlineCloseCircle color="red" size="22px" />
          ) : (
            <BiCircle color="#ccc" size="22px" />
          )}
        </Button>
        <Textarea
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder={intl.formatMessage({
            id: "qc.comment_placeholder",
            defaultMessage: "Comment on decision here",
          })}
        />
        <Button p="4px" onClick={onSubmit}>
          OK
        </Button>
      </Box>
    </Box>
  );
}
